import * as yup from "yup";

export const SaleValidationSchema = yup.object().shape({
    sale_items: yup.array().of(
        yup.object().shape({
            sale_quantity: yup.number().integer('Sell quantity must be integer'),
            item: yup.object().shape({
                id: yup.number(),
                name: yup.string(),
                label: yup.string(),
            })
            .typeError("Please select item"),
        }),
    ),

});


// export const SaleValidationSchema = yup.object().shape({
//     sale_items: yup.array().of(
//         yup.object().shape({
//             sale_quantity: yup.number().required("Sale quantity is Required"),
//             item: yup.object().shape({
//                 id: yup.number().required("Item is Required"),
//                 name: yup.string(),
//                 label: yup.string(),
//             })
//             .typeError("Please select item"),
//         }),
//     ),

// });